import styled from 'styled-components';

const BredcrumbList = styled.ul`
	margin: 0px;
	list-style: none;
	padding: 0px;
`;
export default BredcrumbList;
